import React, {useEffect} from "react";
import { useParams } from "react-router-dom";
import { buyers } from "../Data";
import ErrorPage from './ErrorPage'
import Header from "../Components/Header";
import BreadcrumbMain from "../Components/BreadcrumbMain";
import heroImg from '../Images/buyers-breadcrumb.webp'
import Services from "../Components/Services";
import HomeBlogs from "../Components/HomeBlogs";
import Cta from "../Components/Cta";
import BuyersContent from "../Components/BuyersContent";
import SchemaMarkup from "../Components/SchemaMarkup";
import breadcrumbSchema from '../Schemas/breadcrumbSchema'
import faqSchema from "../Schemas/faqSchema";

const Buyers=()=>{
     const { slug } = useParams();

  const buyer = buyers.find(item => item.slug === slug);

  useEffect(() => {
      if (!buyer) return;
      document.title = `${buyer.metaTitle}`;

      const metaDesc = document.querySelector(
        "meta[name='description']"
      );
      if (metaDesc) {
        metaDesc.setAttribute("content", buyer.metaDesc);
      }

        let canonical = document.querySelector("link[rel='canonical']");
  if (!canonical) {
    canonical = document.createElement("link");
    canonical.setAttribute("rel", "canonical");
    document.head.appendChild(canonical);
  }

  canonical.setAttribute(
    "href",
    `https://ldlsettlementservices.com.au/buyers/${slug}`
  );

   const ogTitle = document.querySelector("meta[property='og:title']");
  if (ogTitle) {
    ogTitle.setAttribute(
      "content",
      buyer.metaTitle
    );
  }

    const ogDesc = document.querySelector("meta[property='og:description']");
  if (ogDesc) {
    ogDesc.setAttribute(
      "content",
      buyer.metaDesc
    );
  }

  const ogUrl = document.querySelector("meta[property='og:url']");
  if (ogUrl) {
    ogUrl.setAttribute("content",  `https://ldlsettlementservices.com.au/buyers/${slug}`);
  }

    const ogImage = document.querySelector("meta[property='og:image']");
  if (ogImage) {
    ogImage.setAttribute(
      "content",
      "https://ldlsettlementservices.com.au/Images/buyer-img.webp"
    );
  }

    const twitterTitle = document.querySelector("meta[name='twitter:title']");
  if (twitterTitle) {
    twitterTitle.setAttribute(
      "content",
     buyer.metaTitle
    );
  }

    const twitterDesc = document.querySelector(
    "meta[name='twitter:description']"
  );
  if (twitterDesc) {
    twitterDesc.setAttribute(
      "content",
    buyer.metaDesc
    );
  }

    const twitterImage = document.querySelector("meta[name='twitter:image']");
  if (twitterImage) {
    twitterImage.setAttribute(
      "content",
      "https://ldlsettlementservices.com.au/Images/buyer-img.webp"
    );
  }

    }, [buyer, slug]);


  if (!buyer) {
    return <ErrorPage />;
  }

    const breadcrumbs = breadcrumbSchema([
  {
    name: "Home",
    url: "https://ldlsettlementservices.com.au/"
  },
  {
    name: buyer.title
  }
]);

const buyerFaqs = buyer.slug === "faqs"
  ? buyer.sections
      .filter((section) => section.type === "faq")
      .map((section) => ({
        question: section.heading,
        answer: [
          ...(section.paragraphs || []),
          ...(section.points || [])
        ].join(" ")
      }))
  : [];
  const faqs = buyer.slug === "faqs"
  ? faqSchema(buyerFaqs)
  : null;

    return(
        <>
        <React.Fragment key={slug}>

          <SchemaMarkup schema={breadcrumbs} />
          {faqs && <SchemaMarkup schema={faqs} />}

        {/**HEADER */}
           <Header
        showBreadcrumb={true}
         breadcrumbItems={[
    {
      label: "Buyers",
    },
    {
      label: buyer.title,
    },
  ]}
      />

      {/**HERO SECTION */}
      <BreadcrumbMain
      subTitle="FOR BUYERS"
      title="The Complete Property Buyer’s Guide"
      specialNote="Your Step-by-Step Settlement Resource"
      description="Everything you need to know about buying property in Western Australia. Explore step-by-step settlement guides, calculate your costs, access specialized first-home buyer advice, and use our practical checklists to guarantee a stress-free settlement."
      image={heroImg}
      showIcons={false}
    />

    {/**CONTENT SECTION */}
    <BuyersContent

        sidebarTitle={
          buyer.sidebarTitle
        }
        type="buyers"
        sidebarLinks={buyers}
        currentSlug={
          buyer.slug
        }
        contentHeading={
          buyer.contentHeading
        }
        intro={
          buyer.intro
        }
        sections={
          buyer.sections
        }
      />

    {/**SERVICE CARDS SECTION */}
    <section className="buyers-pg">
     <Services/>
     </section>

       {/**BLOGS GRID */}
    <HomeBlogs />

     {/**CTA SECTION */}
          <Cta/>

        </React.Fragment>
        </>
    )
}
export default Buyers;